import { datePickerMinDateMaxDateValidate } from '../../../../utils/dateUtil';
import { IfspSDPAndConsentType } from '../../../../redux/features/ifsp/ifspSDPAndConsentSlice';

type ErrorDetailsType = {
  error: boolean;
  errorMessageId: string;
  errorMessage: string;
  errorIndex: number | null;
};
export type ServicdeliveryAndConsnetValidationResultType = {
  reestablishedDate: ErrorDetailsType[];
  assessmentCompletedOn: ErrorDetailsType[];
  adminAmendmentSignature: ErrorDetailsType[];
  adminAmendmentSignDate: ErrorDetailsType[];
  consentToAccessInsuranceSignatureDateOne: ErrorDetailsType[];
  consentToAccessInsuranceSignatureDateTwo: ErrorDetailsType[];
  consentToAccessInsurance: ErrorDetailsType[];
  consentToAccessInsuranceNotSigned: ErrorDetailsType[];
  participatedInIfspDevelopment: ErrorDetailsType[];
  consentForServiceagreeDisagreeService: ErrorDetailsType[];
  consentForServiceSignatureDateOne: ErrorDetailsType[];
  consentForServiceSignatureDateTwo: ErrorDetailsType[];
  consentForServiceNotSigned: ErrorDetailsType[];
};

export const useSDPAndConsentValidationCheck = ({
  consent,
}: IfspSDPAndConsentType): ServicdeliveryAndConsnetValidationResultType => {
  const validationResult: ServicdeliveryAndConsnetValidationResultType = {
    reestablishedDate: [],
    assessmentCompletedOn: [],
    adminAmendmentSignature: [],
    adminAmendmentSignDate: [],
    consentToAccessInsuranceSignatureDateOne: [],
    consentToAccessInsuranceSignatureDateTwo: [],
    consentForServiceagreeDisagreeService: [],
    consentToAccessInsurance: [],
    consentToAccessInsuranceNotSigned: [],
    participatedInIfspDevelopment: [],
    consentForServiceSignatureDateOne: [],
    consentForServiceSignatureDateTwo: [],
    consentForServiceNotSigned: [],
  };

  consent.forEach((item, index) => {
    // =====================Re-established Date===============================
    if (datePickerMinDateMaxDateValidate(item.reestablishmentDate)) {
      validationResult.reestablishedDate.push({
        error: true,
        errorMessageId: 'datePickerMinDateMaxDateValidate',
        errorMessage: 'Re-establishment Date is invalid',
        errorIndex: index,
      });
    } else if (
      item.isEligibleUntilThirdBirthday === 'iseligible' &&
      !item.reestablishmentDate &&
      item.consentType === 'consent'
    ) {
      validationResult.reestablishedDate.push({
        error: true,
        errorMessageId: 'IFSP.SDPAndConsent.reestablishmentDate.required',
        errorMessage: 'Re-establishment Date is required',
        errorIndex: index,
      });
    }

    // =====================Assessment Completed On=============================
    if (
      item.assessmentCompletedOn &&
      datePickerMinDateMaxDateValidate(item.assessmentCompletedOn)
    ) {
      validationResult.assessmentCompletedOn.push({
        error: true,
        errorMessageId: 'datePickerMinDateMaxDateValidate',
        errorMessage: 'Assessment Completed Date is invalid',
        errorIndex: index,
      });
    }

    // =====================Admin Amendment Signature========================
    if (item.isAdminAmendment && !item.adminAmendmentSignature.signature) {
      validationResult.adminAmendmentSignature.push({
        error: true,
        errorMessageId: 'IFSP.SDPAndConsent.adminAmendmentSignature.required',
        errorMessage: 'Admin Amendment Signature is required',
        errorIndex: index,
      });
    }

    // =====================Admin Amendment Signature Date========================
    if (
      item.isAdminAmendment &&
      !item.adminAmendmentSignature.date &&
      (item.adminAmendmentSignature.signature ||
        item.adminAmendmentSignature.partitionKey ||
        item.adminAmendmentSignature.rowKey ||
        item.isConsentSkipped)
    ) {
      validationResult.adminAmendmentSignDate.push({
        error: true,
        errorMessageId:
          'IFSP.SDPAndConsent.adminAmendmentSignatureDate.required',
        errorMessage: 'Admin Amendment Signature Date is required',
        errorIndex: index,
      });
    } else if (
      item.adminAmendmentSignature.date &&
      datePickerMinDateMaxDateValidate(item.adminAmendmentSignature.date)
    ) {
      validationResult.adminAmendmentSignDate.push({
        error: true,
        errorMessageId: 'datePickerMinDateMaxDateValidate',
        errorMessage: 'Admin Amendment Signature Date is invalid',
        errorIndex: index,
      });
    }

    // =====================Consent to Access Insurance Not Signed========================
    if (
      item.consentToAccessInsurance &&
      item.consentToAccessInsuranceSignature.every(
        (signature) =>
          !signature.signature &&
          !signature.partitionKey &&
          !signature.rowKey &&
          !signature.verbalConsent &&
          !signature.paperConsent,
      )
    ) {
      validationResult.consentToAccessInsuranceNotSigned.push({
        error: true,
        errorMessageId:
          item.uiVersion === 1
            ? 'IFSP.SDPAndConsent.consentToAccessInsuranceNotSigned.required'
            : 'IFSP.SDPAndConsent.consentToAccessInsuranceNotSigned.requiredV2',
        errorMessage:
          item.uiVersion === 1
            ? 'Please provide at least one signature or verbal consent in the Consent to Access Insurance section above.'
            : 'Please provide at least one signature or paper consent in the Consent to Access Insurance section above.',
        errorIndex: index,
      });
    }

    // ========================Signature Date One (Access Insurance)=============================
    if (
      !item.consentToAccessInsuranceSignature[0].date &&
      (item.consentToAccessInsuranceSignature[0].signature ||
        item.consentToAccessInsuranceSignature[0].partitionKey ||
        item.consentToAccessInsuranceSignature[0].rowKey ||
        item.consentToAccessInsuranceSignature[0].verbalConsent ||
        item.consentToAccessInsuranceSignature[0].paperConsent)
    ) {
      validationResult.consentToAccessInsuranceSignatureDateOne.push({
        error: true,
        errorMessageId:
          'IFSP.SDPAndConsent.consentToAccessInsuranceSignatureDateOne.required',
        errorMessage: 'Date is required',
        errorIndex: index,
      });
    } else if (
      item.consentToAccessInsuranceSignature[0].date &&
      datePickerMinDateMaxDateValidate(
        item.consentToAccessInsuranceSignature[0].date,
      )
    ) {
      validationResult.consentToAccessInsuranceSignatureDateOne.push({
        error: true,
        errorMessageId: 'datePickerMinDateMaxDateValidate',
        errorMessage: 'Access Insurance Signature Date One is invalid',
        errorIndex: index,
      });
    }

    // =========================Signature Date Two (Access Insurance)=============================
    if (
      !item.consentToAccessInsuranceSignature[1].date &&
      (item.consentToAccessInsuranceSignature[1].signature ||
        item.consentToAccessInsuranceSignature[1].partitionKey ||
        item.consentToAccessInsuranceSignature[1].rowKey ||
        item.consentToAccessInsuranceSignature[1].verbalConsent ||
        item.consentToAccessInsuranceSignature[1].paperConsent)
    ) {
      validationResult.consentToAccessInsuranceSignatureDateTwo.push({
        error: true,
        errorMessageId:
          'IFSP.SDPAndConsent.consentToAccessInsuranceSignatureDateTwo.required',
        errorMessage: 'Date is required',
        errorIndex: index,
      });
    } else if (
      item.consentToAccessInsuranceSignature[1].date &&
      datePickerMinDateMaxDateValidate(
        item.consentToAccessInsuranceSignature[1].date,
      )
    ) {
      validationResult.consentToAccessInsuranceSignatureDateTwo.push({
        error: true,
        errorMessageId: 'datePickerMinDateMaxDateValidate',
        errorMessage: 'Access Insurance Signature Date Two is invalid',
        errorIndex: index,
      });
    }

    // =========================Participated in the development of our IFSP=============================
    if (
      item.consentForServiceSignature.some(
        (signature) =>
          signature.signature ||
          signature.partitionKey ||
          signature.rowKey ||
          signature.verbalConsent ||
          signature.paperConsent,
      ) &&
      !item.participatedInIfspDevelopment
    ) {
      validationResult.participatedInIfspDevelopment.push({
        error: true,
        errorMessageId:
          'IFSP.SDPAndConsent.ParticipatedInIfspDevelopment.required',
        errorMessage:
          'Enable the above checkbox to provide your Consent for Service',
        errorIndex: index,
      });
    }

    // =========================Consent to access insurance=============================
    if (
      item.consentToAccessInsuranceSignature.some(
        (signature) =>
          signature.signature ||
          signature.partitionKey ||
          signature.rowKey ||
          signature.verbalConsent ||
          signature.paperConsent,
      ) &&
      !item.consentToAccessInsurance
    ) {
      validationResult.consentToAccessInsurance.push({
        error: true,
        errorMessageId: 'IFSP.SDPAndConsent.ConsentToAccessInsurance.required',
        errorMessage:
          'Enable the above checkbox to provide Consent to access Insurance',
        errorIndex: index,
      });
    }

    // ======================== Agree Disagree Service =================================
    if (
      item.participatedInIfspDevelopment &&
      !item.agreeDisagreeService &&
      !item.completedOn
    ) {
      validationResult.consentForServiceagreeDisagreeService.push({
        error: true,
        errorMessageId: 'IFSP.SDPAndConsent.agreeDisagreeService.required',
        errorMessage: 'At least one of the options below must be selected.',
        errorIndex: index,
      });
    }

    // =====================Consent for Service Not Signed========================
    const signatures = item.consentForServiceSignature;

    if (
      item.participatedInIfspDevelopment &&
      signatures?.length >= 2 &&
      [signatures[0], signatures[1]].every(
        (signature) =>
          !signature.signature &&
          !signature.partitionKey &&
          !signature.rowKey &&
          !signature.verbalConsent &&
          !signature.paperConsent,
      )
    ) {
      validationResult.consentForServiceNotSigned.push({
        error: true,
        errorMessageId:
          item.uiVersion === 1
            ? 'IFSP.SDPAndConsent.consentForServiceNotSigned.required'
            : 'IFSP.SDPAndConsent.consentForServiceNotSigned.requiredV2',
        errorMessage:
          item.uiVersion === 1
            ? 'Please provide at least one signature or verbal consent in the Consent for Service section above.'
            : 'Please provide at least one signature or paper consent in the Consent for Service section above.',
        errorIndex: index,
      });
    }

    // ========================Signature Date One (Consent for Service)=================================
    if (
      !item.consentForServiceSignature[0].date &&
      (item.consentForServiceSignature[0].signature ||
        item.consentForServiceSignature[0].partitionKey ||
        item.consentForServiceSignature[0].rowKey ||
        item.consentForServiceSignature[0].verbalConsent ||
        item.consentForServiceSignature[0].paperConsent)
    ) {
      validationResult.consentForServiceSignatureDateOne.push({
        error: true,
        errorMessageId:
          'IFSP.SDPAndConsent.consentForServiceSignatureDateOne.required',
        errorMessage: 'Date is required',
        errorIndex: index,
      });
    } else if (
      item.consentForServiceSignature[0].date &&
      datePickerMinDateMaxDateValidate(item.consentForServiceSignature[0].date)
    ) {
      validationResult.consentForServiceSignatureDateOne.push({
        error: true,
        errorMessageId: 'datePickerMinDateMaxDateValidate',
        errorMessage: 'Service Signature Date One is invalid',
        errorIndex: index,
      });
    }

    // =======================Signature Date Two (Consent for Service)============================
    if (
      !item.consentForServiceSignature[1].date &&
      (item.consentForServiceSignature[1].signature ||
        item.consentForServiceSignature[1].partitionKey ||
        item.consentForServiceSignature[1].rowKey ||
        item.consentForServiceSignature[1].verbalConsent ||
        item.consentForServiceSignature[1].paperConsent)
    ) {
      validationResult.consentForServiceSignatureDateTwo.push({
        error: true,
        errorMessageId:
          'IFSP.SDPAndConsent.consentForServiceSignatureDateTwo.required',
        errorMessage: 'Date is required',
        errorIndex: index,
      });
    } else if (
      item.consentForServiceSignature[1].date &&
      datePickerMinDateMaxDateValidate(item.consentForServiceSignature[1].date)
    ) {
      validationResult.consentForServiceSignatureDateTwo.push({
        error: true,
        errorMessageId: 'datePickerMinDateMaxDateValidate',
        errorMessage: 'Service Signature Date Two is invalid',
        errorIndex: index,
      });
    }
  });

  return validationResult;
};
